import { IframeApps } from '../components/common/persistentIframeRenderer/constants';
import {
  IFRAME_SET_VISIBILITY,
  IFRAME_SET_DIMENSIONS,
  IFRAME_SET_LOADED,
  IFRAME_SET_RENDERED,
  IFRAME_SET_CLASSNAME,
  IFRAME_SET_SLOT_CLOSE_REQUEST,
} from '../actions/constants';
import { objectHasOwnProperty } from '../utils/utils';

const getDefaultDimensions = () => ({
  top: 0,
  left: 0,
  width: 0,
  height: 0,
});

const getDefaultAppEntry = () => ({
  visibility: false,
  dimensions: getDefaultDimensions(),
  isLoaded: false,
  isRendered: false,
  className: '',
  closeRequestedSlot: null,
});

const getDefaultState = () => {
  const defaultState: any = {};
  // Built-in iframe apps are seeded here. Custom-frontend apps from the
  // masterdata manifest have open keys — their entries materialize on
  // first dispatch via `getAppEntry` below.
  for (const value in IframeApps) {
    if (objectHasOwnProperty(IframeApps, value)) {
      defaultState[IframeApps[value]] = getDefaultAppEntry();
    }
  }
  return defaultState;
};

const getAppEntry = (state: any, appName: string) =>
  state[appName] || getDefaultAppEntry();

export default function (state: any = getDefaultState(), action) {
  switch (action.type) {
    case IFRAME_SET_VISIBILITY: {
      const existing = getAppEntry(state, action.appName);
      // Reset dimensions if visibility is false
      const dimensionToSet = action.visibility ?
        existing.dimensions : getDefaultDimensions();
      return {
        ...state,
        [action.appName]: {
          ...existing,
          visibility: action.visibility,
          dimensions: dimensionToSet,
        },
      };
    }

    case IFRAME_SET_DIMENSIONS: {
      return {
        ...state,
        [action.appName]: {
          ...getAppEntry(state, action.appName),
          dimensions: action.dimensions,
        },
      };
    }

    case IFRAME_SET_LOADED: {
      return {
        ...state,
        [action.appName]: {
          ...getAppEntry(state, action.appName),
          isLoaded: action.isLoaded,
        },
      };
    }

    case IFRAME_SET_RENDERED: {
      return {
        ...state,
        [action.appName]: {
          ...getAppEntry(state, action.appName),
          isRendered: action.isRendered,
        },
      };
    }

    case IFRAME_SET_CLASSNAME: {
      return {
        ...state,
        [action.appName]: {
          ...getAppEntry(state, action.appName),
          className: action.className,
        },
      };
    }

    case IFRAME_SET_SLOT_CLOSE_REQUEST: {
      return {
        ...state,
        [action.appName]: {
          ...getAppEntry(state, action.appName),
          closeRequestedSlot: action.slot,
        },
      };
    }

    default: return state;
  }
}
